import { useState } from 'react';

type usePaginationProps = {
  limit: number;
}

export const usePagination = (props: usePaginationProps) => {
  const { limit } = props;
  const [page, setPage] = useState(1);
  const offset = limit * (page - 1);

  return {
    offset,
    page,
    nextPage: (total: number) => {
      const maxPage = Math.ceil(total / limit);
      if (maxPage !== page) {
        setPage(page + 1);
      }
    },
  };
};

export default usePagination;
